
function authGuardRoute(to, from, next) {
  var isAuthenticated = false;
  var getAuth = localStorage.getItem('IsAuthenticated');
  if (getAuth === null) { isAuthenticated = false; }

  if (getAuth) {
    next();
  }
  else {
    next('/login')
  }
}

let rolesAccess = [];
function roleGuardRoute(to, from, next) {
  var getAuth = localStorage.getItem('IsAuthenticated');
  let user = JSON.parse(localStorage.getItem('UserRoles')) //get userRoles
  let menuList = JSON.parse(localStorage.getItem('menuList')) //get userMenus
  const toplineMenus = menuList.filter((p) => p.name === "topline"); //get topline menus

  const userToplineMenus = []; // get topline path
  if (toplineMenus[0] != undefined) {
    toplineMenus[0].children.forEach((element) => {
      userToplineMenus.push(element.path.toLowerCase());
    });
  }

  const lacksRole = to.matched.some(route => {
    rolesAccess = user.filter(p => route.meta.roles.includes(p))
    return route.meta.roles
  })

  // check accessibility rout  
  if (lacksRole && (rolesAccess.length <= 0 || getAuth === null || userToplineMenus.filter(p => p.includes(to.fullPath.toLowerCase())).length <= 0)) {
    // localStorage.clear()
    alert('شما به این بخش دسترسی ندارین!!!')
    return next('/')  // Aborts the navigation request
  }
  next()
}

export default [

  {
    path: '',
    name: '',
    // beforeEnter: roleGuardRoute,
    component: () => import("@/components/tourism/TourismSearch")
  },
  {
    path: 'tourismSearch/:providerName',
    // beforeEnter: roleGuardRoute,
    component: () => import("@/components/tourism/TourismSearch")
  },
  {
    path: 'tourismBook/:providerName',
    // beforeEnter: authGuardRoute,
    component: () => import("@/components/tourism/TourismBook")
  },
  {
    path: 'confirmbook/:providerName',
    // beforeEnter: authGuardRoute,
    component: () => import("@/components/tourism/TourismConfirm")
  },

  {
    path: 'printTicket/:providerName/:bookingId?',
    component: () => import("@/components/tourism/PrintTicket")
  },

  {
    path: 'bankPaymentError/:providerName/:errorMessage?',
    component: () => import("@/components/tourism/BankPaymentError")
  },

  { path: "***", redirect: "/" },
];
